/** Estados de compra — recepción oficial vs legacy (PUT histórico). */
export const COMPRA_ESTADO_RECIBIDA = 'recibida';
export const COMPRA_ESTADO_LEGACY_RECIBIDA = 'completada';

export function normalizeCompraEstado(estado) {
  return String(estado || '').trim().toLowerCase();
}

/** Compra ya ingresada al inventario (oficial o legacy). */
export function isCompraRecibida(estado) {
  const e = normalizeCompraEstado(estado);
  return e === COMPRA_ESTADO_RECIBIDA || e === COMPRA_ESTADO_LEGACY_RECIBIDA;
}

export function isCompraPendiente(estado) {
  return normalizeCompraEstado(estado) === 'pendiente';
}

/** Etiqueta UI; `completada` se muestra como recibida legacy. */
export function getCompraEstadoLabel(estado) {
  const e = normalizeCompraEstado(estado);
  if (e === COMPRA_ESTADO_RECIBIDA) return 'Recibida';
  if (e === COMPRA_ESTADO_LEGACY_RECIBIDA) return 'Recibida (legacy)';
  if (e === 'pendiente') return 'Pendiente';
  if (e === 'cancelada') return 'Cancelada';
  if (e === 'devuelta') return 'Devuelta';
  if (!e) return '—';
  return e.charAt(0).toUpperCase() + e.slice(1);
}

/** Etiqueta de pago / factura para el flujo proveedor (sin inventar deuda). */
export function getCompraPagoFlujoLabel(compra) {
  if (!compra) return '—';
  const estado = normalizeCompraEstado(compra.estado);
  const pago = normalizeCompraEstado(compra.estado_pago || 'pendiente');
  if (estado === 'cancelada' || estado === 'devuelta') return getCompraEstadoLabel(estado);
  if (pago === 'pagado' || pago === 'pagada') return 'Pagada';
  if (pago === 'parcial') return 'Pago parcial';
  if (isCompraRecibida(estado)) return 'Recibida · pendiente de factura';
  if (estado === 'pendiente') return 'Pendiente de recepción · sin deuda';
  return 'Pendiente de pago';
}

export function compraNecesitaFactura(compra) {
  if (!compra || !isCompraRecibida(compra.estado)) return false;
  const pago = normalizeCompraEstado(compra.estado_pago || 'pendiente');
  return pago !== 'pagado' && pago !== 'pagada';
}

/**
 * Advertencia segura si hay líneas que no generarán movimiento de stock.
 * @returns {number} cantidad de líneas inválidas
 */
export function warnDetallesSinProductoId(detalles, compraId = '') {
  if (!Array.isArray(detalles)) return 0;
  const invalidas = detalles.filter(
    (d) => !d?.producto_id || !(parseFloat(d?.cantidad) > 0)
  );
  if (invalidas.length > 0) {
    const prefix = compraId ? ` Compra ${compraId}:` : '';
    console.warn(
      `[COMPRAS]${prefix} ${invalidas.length} línea(s) sin producto_id o cantidad válida — el stock puede no incrementarse para esas líneas.`
    );
  }
  return invalidas.length;
}
